import React, { useCallback, useState, useMemo, useEffect, useRef } from "react";
import Table from "../../../../../../../common/element/Table";
import Button from "../../../../../../../common/element/Buttons";
import { useLocation, useNavigate } from "react-router-dom";
import { debounce } from "../../../../../../../common/snippet/Debouncing";
import ClientInput from "../../../../../../../common/element/Input/clientInput";
import ModernPagination from "../../../../../../../common/pagination/ModernPagination";
import { Pagination } from "../../../../../../../common/pagination";
import ToolManagmentCard from "../../../../../../../common/element/Card/ToolManagmnetCard";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../../../../../../../redux/auth/authSelector";
import { setBreadcrumbs } from "../../../../../../../redux/Admin/breadcrumbsSlice";
import Heading from "../../../../../../../common/element/Heading";
import Select from "../../../../../../../common/element/Select";
import {
  getEmployeeSessions,

} from "../../../../../../../redux/Employee/employeesSlice";
import {

  selectEmployeeSessions,
  selectEmployeeSessionsLoading,
  selectEmployeeSessionsError,
  selectEmployeeSessionsTotal
} from "../../../../../../../redux/Employee/employeesSelector";
import ThreeDotBouncingLoader from "../../../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import { setsessionName } from "../../../../../../../redux/Admin/sessionViewSlice";
import CommonIconButton from "../../../../../../../common/icons/CommonIconButton";

const { Tr, Th, Td, THead, TBody } = Table;

const SessionList = (props) => {
  const [countData, setCountData] = useState(0);
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [mainCheck, setMainCheck] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const userData = useSelector(selectUserData);
  const userRole = userData?.role_name;

  // Get employee sessions from Redux
  const sessionsData = useSelector(selectEmployeeSessions);
  console.log(sessionsData, "sessionsDatasessionsData")
  const sessionsLoading = useSelector(selectEmployeeSessionsLoading);
  const sessionsError = useSelector(selectEmployeeSessionsError);
  const sessionsTotal = useSelector(selectEmployeeSessionsTotal);

  const searchParams = new URLSearchParams(location.search);
  const employeeId = searchParams.get('employeeId');
  const tab = searchParams.get('tab');
  const companyId = searchParams.get('companyId');

  const [batchId, setBatchId] = useState("");
  const [formError, setFormErrors] = useState({});

  const [getFilterData, SetFilterData] = useState({
    function_assignment_id: "",
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    search: "",
  });

  // Fetch sessions on component mount and when filters change
  useEffect(() => {
    const params = {
      page: filterpage,
      limit: filterlimit,
    };

    // Only send employeeId if it exists in the route
    if (employeeId) {
      params.employeeId = employeeId;
    }

    // Add search if exists
    if (getFilterData.search) {
      params.search = getFilterData.search;
    }

    dispatch(getEmployeeSessions(params));
  }, [dispatch, employeeId, filterpage, filterlimit, getFilterData.search]);

  // Update count when sessions total changes
  useEffect(() => {
    setCountData(sessionsTotal);
    setTotalPages(Math.ceil(sessionsTotal / filterlimit));
  }, [sessionsTotal, filterlimit]);

  const handleInputChange = (field, value) => {
    if (field === "batch") {
      setBatchId(value);
    }
    if (formError[field]) setFormErrors(prev => ({ ...prev, [field]: "" }));
  };

  const onCheckboxChange = (checked, item) => {
    if (item === "mainCheck") {
      setMainCheck(checked);
      setCheckedItems(checked ? sessionsData : []);
    } else {
      if (checked) {
        setCheckedItems([...checkedItems, item]);
      } else {
        setCheckedItems(checkedItems.filter((i) => i.id !== item.id));
      }
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.trim();
    SetFilterData((prev) => ({ ...prev, search: value }));
  };

  const inputchangehandler = useCallback(debounce(handleSearch), []);

  const handlePageChange = (page) => {
    setfilterpage(page);
  };

  // Format date helper
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  // Transform API data to match table structure
  // Transform API data to match table structure
  const transformedData = useMemo(() => {
    if (!sessionsData || !Array.isArray(sessionsData)) return [];

    // Handle if sessionsData is wrapped in a data property
    const dataArray = Array.isArray(sessionsData) ? sessionsData : (sessionsData?.data || []);

    return dataArray.map((item) => ({
      id: item.id,
      sessionId: item.companySession?.company_session_id,
      sessionName: item.companySession?.session_name || item.companySession?.session?.session_name || "N/A",
      batch: "N/A",
      batchId: "",
      status: item.status || item.companySession?.status || "ongoing",

      // ----------- FIXED LINE BELOW -----------
      coach: item.companySession?.coach
        ? `${item.companySession.coach.first_name} ${item.companySession.coach.last_name}`
        : "N/A",
      // ----------------------------------------

      date: formatDate(item.companySession?.session_date),
      hasAssignment: item.companySession?.assignment_enabled || false,
      hasTool: item.companySession?.tool_enabled || false,
      hasSupportedDoc: item.companySession?.supported_doc_enabled || false,
    }));
  }, [sessionsData]);
  // Filter logic - Remove client-side filtering since API handles it
  const filteredData = useMemo(() => {
    let data = transformedData;

    // Filter by batch (client-side only)
    if (batchId && batchId !== "") {
      data = data.filter(item => item.batchId === batchId);
    }

    return data;
  }, [transformedData, batchId]);

  // Since API handles pagination, use filteredData directly
  const paginatedData = filteredData;

  const hasSetBreadcrumbs = useRef(false);

  useEffect(() => {
    if ((userRole === "HR" || userRole === "Employee" || userRole === "Company Admin" || userRole === "Management" || userRole === "Science Of Self" ||userRole === "Sales Training Company" ) && !hasSetBreadcrumbs.current) {
      const crumbs = [
        { label: "Session", url: "/sessions", home: "/sessions" },
      ];
      dispatch(setBreadcrumbs(crumbs));
      hasSetBreadcrumbs.current = true;
    }
  }, [dispatch, userRole]);

  const StatusBadge = ({ status }) => {
    const getStatusStyles = () => {
      const normalizedStatus = status?.toLowerCase();
      switch (normalizedStatus) {
        case "completed": return "text-green-600 bg-green-50";
        case "ongoing": return "text-yellow-600 bg-yellow-50";
        case "upcoming": return "text-blue-600 bg-blue-50";
        case "cancelled": return "text-red-600 bg-red-50";
        default: return "text-gray-600 bg-gray-50";
      }
    };



    return (
      <span
        className={`px-3 py-1 rounded-full font-lato not-italic font-medium  leading-[150%] capitalize ${getStatusStyles()}`}
      >
        {status || "N/A"}
      </span>
    );
  };

  const ContentWrapper = userRole === "Admin" ? ToolManagmentCard : React.Fragment;

  // Show loader while fetching
  // Show error if any
  if (sessionsError) {
    return (
      <ContentWrapper>
        <div className="flex justify-center items-center h-64">
          <p className="text-red-500">Error: {sessionsError}</p>
        </div>
      </ContentWrapper>
    );
  }

  return (
    <>
      <ContentWrapper>
        {userRole === "Admin" ? (
          <div className="flex justify-between items-center pb-4 border-b border-gray-200">
            <h2 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828]">Sessions</h2>
            <div className="flex justify-end ">
              <div className="input-wrapper">
                <div className="input-suffix-start left-3.5">
                  <img
                    src="/assets/icons-svg/search-lg.svg"
                    alt=""
                    className="h-5"
                  />
                </div>
                <ClientInput
                  type="text"
                  className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="Search"
                  inputchangehandler={inputchangehandler}
                  name={"search"}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="flex justify-between mb-5">
            <div className="h-10 text-start">
              <Heading>{userRole === "Employee" ? "Sessions" : "My Sessions"}</Heading>
            </div>

            <div className="flex justify-end gap-3">
              <div className="input-wrapper">
                <div className="input-suffix-start left-3.5">
                  <img
                    src="/assets/icons-svg/search-lg.svg"
                    alt=""
                    className="h-5"
                  />
                </div>
                <ClientInput
                  type="text"
                  className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="Search"
                  inputchangehandler={inputchangehandler}
                  name={"search"}
                />
              </div>
            </div>
          </div>
        )}

        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden mt-4">
          <Table className="w-full ">
            <THead>
              <Tr className="bg-[#F9F9FB] text-gray-600 text-xs">
                <Th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">S No.</Th>
                <Th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">Session Name</Th>
                <Th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">Status</Th>
                <Th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">Coach</Th>
                <Th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">Date</Th>
                <Th className="py-3 px-4 text-center font-lato font-medium text-sm leading-[1.5] text-[#475467]">Action</Th>
              </Tr>
            </THead>

            <TBody>
              {sessionsLoading ? (
                <Tr>
                  <Td
                    colSpan={6}
                    className="text-center text-gray-500 py-10 text-sm"
                  >
                    <div className="flex justify-center items-center">
                      <ThreeDotBouncingLoader />
                    </div>
                  </Td>
                </Tr>
              ) : sessionsError ? (
                <Tr>
                  <Td
                    colSpan={6}
                    className="text-center py-6 text-sm"
                  >
                    <p className="text-red-500">Error: {sessionsError}</p>
                  </Td>
                </Tr>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((item, index) => (
                  <Tr
                    key={item.id}
                    className="border-t border-gray-100 hover:bg-gray-50 transition-colors text-start"
                  >
                    <Td className="py-3 px-4 font-lato font-medium text-sm leading-[1.5] text-[#1D2939]">
                      {String((filterpage - 1) * filterlimit + index + 1).padStart(2, "0")}
                    </Td>
                    <Td className="py-3 px-4 font-lato font-medium text-sm leading-[1.5] text-[#1D2939]">{item.sessionName}</Td>
                    <Td className="px-3 py-1  font-lato font-medium text-md leading-[1.5] text-[#1D2939] text-capitalize">
                      <StatusBadge status={item.status} />

                    </Td>
                    <Td className="py-3 px-4 font-lato font-medium text-sm leading-[1.5] text-[#1D2939]">{item.coach}</Td>
                    <Td className="py-3 px-4 font-lato font-medium text-sm leading-[1.5] text-[#1D2939]">{item.date}</Td>
                    {(userRole === "HR" || userRole === "Employee" || userRole === "Company Admin" || userRole === "Management" || userRole === "Science Of Self" || userRole === "Sales Training Company") ? (
                      <Td className="py-3 px-4 font-lato font-medium text-sm leading-[1.5] text-[#1D2939] text-center">
                        <div className="flex gap-1 justify-start">
                          <CommonIconButton
                            type="view"
                            onClick={() => {
                              const name = item.sessionName || '';
                              if (name) dispatch(setsessionName(name));

                              navigate(`/sessions/view?sessionId=${item.sessionId}&sessionName=${item.sessionName}`);
                            }}
                          />
                           
                        </div>
                      </Td>
                    ) : (
                      <Td className="py-3 px-4 font-lato font-medium text-sm leading-[1.5] text-[#1D2939] text-center">
                        <CommonIconButton
                            type="view"
                          onClick={() => {
                            const name = item.sessionName || '';
                            if (name) dispatch(setsessionName(name));
                            navigate(`?companyId=${companyId}&tab=${tab}&employeeId=${employeeId}&sessionView=view&sessionId=${item.sessionId}`);
                          }}
                        />
                        
                      </Td>
                    )}
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td
                    colSpan={6}
                    className="text-center text-gray-500 py-6 text-sm"
                  >
                    No matching records found
                  </Td>
                </Tr>
              )}
            </TBody>
          </Table>
        </div>
        <div className="flex justify-between items-center mt-3">
          <Pagination
            totalCount={countData}
            pageNumber={filterpage}
            displayPage={paginatedData.length}
            UpdatePageLimit={setfilterlimit}
            UpdatePage={setfilterpage}
          />

          {countData > 0 && totalPages > 1 && (
            <ModernPagination
              totalPages={totalPages}
              currentPage={filterpage}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </ContentWrapper>
    </>
  );
};

export default SessionList;